import { Button } from 'antd';
import { useCompanyGeneralDataForm } from '../CompanyGeneralDataFormContext';

/** Ownership structure list. */
export default function CompanyOwnershipFields() {
  const {
    filteredOwnershipStructure,
    ownershipStructureState,
    sectionClass,
    setOpen,
    t,
  } = useCompanyGeneralDataForm();

  return (
    <div className={sectionClass('vlasnistvo')}>
      <p className="mb-2">{t('authorizationAndOwnership', { ns: 'forms' })}</p>

      <div className="mb-5 rounded border bg-zinc-50 p-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-2">
            <p>{t('authorizedPersons', { ns: 'forms' })}:</p>

            <ul className="flex flex-wrap gap-2 [&_li]:rounded-md [&_li]:border [&_li]:bg-white">
              {filteredOwnershipStructure?.length ? (
                <>
                  {filteredOwnershipStructure.map(({ name }) => {
                    return (
                      <li className="block px-2" key={name}>
                        {name}
                      </li>
                    );
                  })}
                </>
              ) : (
                <li className="block px-2">~</li>
              )}
            </ul>
          </div>

          {ownershipStructureState?.visible && (
            <Button
              type="primary"
              className="btn-primary"
              onClick={setOpen}
              disabled={ownershipStructureState?.disabled}
            >
              {t('editOwnershipStructure', { ns: 'forms' })}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
